<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <ul class="step-progress">
                    <li :class="{active: wizardSection > 0}" class="step1" v-tooltip="'Орқага'" @click="previousStep()">
                        Кучмас мулк асосий маълумотларини сақлаш
                    </li>
                    <li :class="{active: wizardSection >= 2}">Ёндашувларни ҳисоблаш</li>
                    <li :class="{active: wizardSection >= 3}">Мувофиқлаштириш ва тасдиқлаш</li>
                    <li :class="{active: wizardSection > 3}">Тамом</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NewRealEstateStepProgress",
        props: {
            realEstate: Object,
            wizardSection: {
                default: 0,
                type:Number
            },
            wizardOptions: Array
        },
        data() {
            return {
                processing: false
            }
        },
        methods: {
            previousStep() {
                if (this.realEstate && this.realEstate.id
                    && this.wizardSection > 0 && this.canSave) {

                    this.realEstate.wizardSection = this.wizardSection - 1;
                    this.processing = true;
                    this.$http.post('/admin/new-real-estate/previous-step', this.realEstate)
                        .then(res => {
                            this.processing = false;
                            if (res.data.status === "SUCCESS") {
                                this.$swal({
                                    title: this.$t('messages.common.success'),
                                    text: this.$t('messages.realEstate.success'),
                                    type: 'success'
                                });
                            } else {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.realEstate.error'),
                                    type: 'error'
                                });
                            }
                        },err => {
                            console.log(err);
                            this.processing = false;
                        });
                }
            }
        },
        computed: {
            canSave() {
                return (this.realEstate.status === 'Pending' || this.realEstate.status === 'AssignedToEvaluator' || this.realEstate.status === 'NotFullyEvaluated');
            },
        }
    }
</script>

<style scoped>

    .step-progress {
        margin: 0;
        padding: 0;
        counter-reset: step;
        display: flex;
        justify-content: center;
    }

    .step-progress li {
        list-style-type: none;
        width: 20%;
        float: left;
        font-size: 12px;
        position: relative;
        text-align: center;
        font-weight: bold;
        text-transform: uppercase;
        color: #7d7d7d;
    }

    .step-progress li:before {
        width: 40px;
        height: 40px;
        content: counter(step);
        counter-increment: step;
        line-height: 40px;
        border: 2px solid #7d7d7d;
        display: block;
        text-align: center;
        margin: 0 auto 10px auto;
        border-radius: 50%;
        background-color: white;
    }

    .step-progress li:after {
        width: 100%;
        height: 2px;
        content: '';
        position: absolute;
        background-color: #7d7d7d;
        top: 15px;
        left: -50%;
        z-index: -1;
    }

    .step-progress li:first-child:after {
        content: none;
    }
    .step-progress li.active {
        color: green;
    }
    .step-progress li.active:before {
        border-color: #55b776;
    }
    .step-progress li.active + li:after {
        background-color: #55b776;
    }

    .step1 {
        cursor: pointer;
    }
</style>